import React, { useState, useRef, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import Form, {
  Item,
  Label,
  ButtonItem,
  ButtonOptions,
  RequiredRule,
  CustomRule,
  EmailRule,
} from "devextreme-react/form";
import notify from "devextreme/ui/notify";
import LoadIndicator from "devextreme-react/load-indicator";
import { createAccount } from "../../api/auth";

import { useTranslation } from "react-i18next";

import "./CreateAccountForm.scss";

export default function CreateAccountForm() {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const formData = useRef({ email: "", password: "" });

  const emailEditorOptions = {
    stylingMode: "filled",
    placeholder: t("Email"),
    mode: "email",
  };
  const passwordEditorOptions = {
    stylingMode: "filled",
    placeholder: t("Password"),
    mode: "password",
  };
  const confirmedPasswordEditorOptions = {
    stylingMode: "filled",
    placeholder: t("Confirm Password"),
    mode: "password",
  };

  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      const { email, password } = formData.current;
      setLoading(true);

      const result = await createAccount(email, password);
      setLoading(false);

      if (result.isOk) {
        navigate("/login");
      } else {
        notify(result.message, "error", 2000);
      }
    },
    [navigate]
  );

  const confirmPassword = useCallback(
    ({ value }) => value === formData.current.password,
    []
  );

  return (
    <form className={"create-account-form"} onSubmit={onSubmit}>
      <Form formData={formData.current} disabled={loading}>
        <Item
          dataField={"email"}
          editorType={"dxTextBox"}
          editorOptions={emailEditorOptions}
        >
          <RequiredRule message={t("Email is required")} />
          <EmailRule message={t("Email is invalid")} />
          <Label visible={false} />
        </Item>
        <Item
          dataField={"password"}
          editorType={"dxTextBox"}
          editorOptions={passwordEditorOptions}
        >
          <RequiredRule message={t("Password is required")} />
          <Label visible={false} />
        </Item>
        <Item
          dataField={"confirmedPassword"}
          editorType={"dxTextBox"}
          editorOptions={confirmedPasswordEditorOptions}
        >
          <RequiredRule message={t("Password is required")} />
          <CustomRule
            message={t("Passwords do not match")}
            validationCallback={confirmPassword}
          />
          <Label visible={false} />
        </Item>
        <Item>
          <div className="policy-info">
            {t("By creating an account, you agree to the")}{" "}
            <Link to="#">{t("Terms of Service")}</Link> {t("and")}{" "}
            <Link to="#">{t("Privacy Policy")}</Link>
          </div>
        </Item>
        <ButtonItem>
          <ButtonOptions
            width={"100%"}
            type={"default"}
            useSubmitBehavior={true}
          >
            <span className="dx-button-text">
              {loading ? (
                <LoadIndicator width={"24px"} height={"24px"} visible={true} />
              ) : (
                t("Create a new account")
              )}
            </span>
          </ButtonOptions>
        </ButtonItem>
        <Item>
          <div className={"login-link"}>
            {t("Have an account?")} <Link to={"/login"}>{t("Sign In")}</Link>
          </div>
        </Item>
      </Form>
    </form>
  );
}
